import { render, staticRenderFns } from "./EventItemQuantity.vue?vue&type=template&id=3d3cab88&scoped=true"
import script from "./EventItemQuantity.vue?vue&type=script&lang=js"
export * from "./EventItemQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3cab88",
  null
  
)

export default component.exports